"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = buildImageUrl;
// Crop around the image's stored Amplience point-of-interest metadata instead of
// the centre. Braces are %7B/%7D-encoded so the URL survives non-browser handling
// (new URL(), proxies); Amplience decodes and resolves the binding at delivery.
const POI_TRANSFORM = "scaleFit=poi&poi=" +
    "%7B$this.metadata.pointOfInterest.x%7D," +
    "%7B$this.metadata.pointOfInterest.y%7D," +
    "%7B$this.metadata.pointOfInterest.w%7D," +
    "%7B$this.metadata.pointOfInterest.h%7D";
function buildImageUrl(rawUrl, params, { applyPoi = false } = {}) {
    // Console preview templates pass Mustache tokens (e.g. "{{ctImage}}") in place
    // of image URLs. These are not valid URLs, so pass them through untouched
    // instead of throwing. Real image URLs never contain "{{".
    if (rawUrl.includes("{{"))
        return rawUrl;
    const url = new URL(rawUrl.trim());
    url.search = "";
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    const result = url.toString();
    return applyPoi ? `${result}&${POI_TRANSFORM}` : result;
}
